{
  "jira-nin-grid-navigation-onboarding.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-nin-grid-navigation-onboarding.enterEscapeNavigation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Enter"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " activates inline edit mode while "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Escape"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " returns you to cell navigation."
    }
  ],
  "jira-nin-grid-navigation-onboarding.heading": [
    {
      "type": 0,
      "value": "Improved keyboard navigation"
    }
  ],
  "jira-nin-grid-navigation-onboarding.homeEndPageNavigation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Home"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " skips to the first cell in a row, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "End"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to the last. "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Page Down"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " scrolls 1 page down, "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "Page Up"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " scrolls 1 page up, keeping focus in the same cell."
    }
  ],
  "jira-nin-grid-navigation-onboarding.moreShortcuts": [
    {
      "type": 0,
      "value": "More shortcuts"
    }
  ],
  "jira-nin-grid-navigation-onboarding.okButton": [
    {
      "type": 0,
      "value": "Ok"
    }
  ],
  "jira-nin-grid-navigation-onboarding.tabAndArrowNavigation": [
    {
      "children": [
        {
          "type": 0,
          "value": "Tab"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " into and out of the view quickly, and use "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "arrow keys"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " to navigate cells."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.closeButton.nonfinal": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescription.nonfinal": [
    {
      "type": 0,
      "value": "Want us to apply your current filter and group settings to this new List view?"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNo.nonfinal": [
    {
      "type": 0,
      "value": "No"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYes.nonfinal": [
    {
      "type": 0,
      "value": "Yes"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.description.nonfinal": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience. A new List view."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.filtersAndGroupsDescription.nonfinal": [
    {
      "type": 0,
      "value": "Any existing filters and groups will be applied."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.heading.nonfinal": [
    {
      "type": 0,
      "value": "We've merged List and All Work"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.learnMoreLink.nonfinal": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.body.nonfinal": [
    {
      "type": 0,
      "value": "We've merged the best of List and All Work into a faster, accessible experience. A new List view."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss.nonfinal": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label.nonfinal": [
    {
      "type": 0,
      "value": "Explore List view"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.filter.nonfinal": [
    {
      "type": 0,
      "value": "One place to search work and filter results to find what you need."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.heading.nonfinal": [
    {
      "type": 0,
      "value": "We've merged List and All Work views"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions.nonfinal": [
    {
      "type": 0,
      "value": "Dive deeper - view work items as a chart, use format rules to highlight key work, and more."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.next.nonfinal": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.ok.nonfinal": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.tell-me-more-aria-label.nonfinal": [
    {
      "type": 0,
      "value": "Read our community post about the merge of List and All Work views"
    }
  ]
}